import React, { useEffect, useState } from "react";
import { Box, Typography, Paper } from "@mui/material";
import { useLocation } from "react-router-dom";
import apiService from "../../utils/api";

const PrintOrders = () => {
  const location = useLocation();
  const orders = location.state.selectedIds || [];
  const [orderDetails, setOrderDetails] = useState([]);
  const [labelWidth, setLabelWidth] = useState("5.08");
  const [labelHeight, setLabelHeight] = useState("2.54");

  useEffect(() => {
    const fetchData = async () => {
      const authToken = sessionStorage.getItem("authToken");
      if (authToken) {
        const [allergyResponse, labelConfigResponse] = await Promise.all([
          apiService.getAllergens(authToken),
          apiService.getLabelConfig(authToken),
        ]);

        const config = labelConfigResponse.data;
        setLabelWidth(config.labelWidth);
        setLabelHeight(config.labelHeight);

        const updatedOrders = orders.map((order) => {
          const allergens = order.orderFoodItem[0].foodItemAllergens.map((allergenId) => allergyResponse.data.find((allergen) => allergen.allergenId === allergenId).allergenName);

          return {
            class: order.orderStudent.studentClass.className,
            studentName: order.orderStudent.studentName,
            foodItemName: order.orderFoodItem[0].foodItemName,
            orderDate: order.orderDate.slice(0, 10),
            allergens,
          };
        });

        setOrderDetails(updatedOrders);
      }
    };

    fetchData();
  }, [orders]);

  return (
    <Box p={0}>
      {orderDetails.map((order, index) => (
        <Paper key={index} style={{ width: `${labelWidth}cm`, height: `${labelHeight}cm`, display: "flex", flexDirection: "column", overflow: "hidden" }}>
          <Box display="flex" flexDirection="column" style={{ marginTop: "6px", marginLeft: "20px"}}>
          <Typography variant="printLabelHeader">{order.class}</Typography>
          <Typography variant="printLabel" >{order.studentName}</Typography>
          <Typography variant="printLabel">{order.foodItemName}</Typography>
          <div style={{ display: 'flex', alignItems: 'baseline' }}>
            <Typography variant="printLabel">Contains Allergens: <span style={{fontWeight: 600}}>{order.allergens.join(', ')}</span></Typography>
          </div>
          <Typography variant="printLabel">Order Date: {order.orderDate}</Typography>
          </Box>
        </Paper>
      ))}
    </Box>
  );
  
            }

export default PrintOrders;
